import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatRadioButton,
    MatRadioGroup,
    ReactiveFormsModule,
    TranslatePipe,
    MatIcon,
  ],
  selector: 'app-change-step-action-selection-dialog',
  styleUrl: './change-step-action-selection-dialog.component.scss',
  templateUrl: './change-step-action-selection-dialog.component.html',
})
export class ChangeStepActionSelectionDialogComponent {
  public readonly formGroup = new FormGroup({
    selectedAction: new FormControl<'saveAndComplete' | 'justSave' | null>(null, [Validators.required]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      isSaveAndCompleteOptionDisabled: boolean;
    },
    private readonly dialogRef: MatDialogRef<ChangeStepActionSelectionDialogComponent>,
  ) {
    this.formGroup.reset({
      selectedAction: this.data.isSaveAndCompleteOptionDisabled ? 'justSave' : 'saveAndComplete',
    });
  }

  public onFormDialogSubmit(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this.dialogRef.close(this.formGroup.value.selectedAction);
  }
}
